import "./hb-phone.module.css";
import { html } from "lit-html";
import { isPopup, getHero } from "../../global";

export const COUNTRY_FLAGS = {
    "+1": "🇺🇸",
    "+855": "🇰🇭",
    "+358": "🇫🇮",
    "+380": "🇺🇦"
};

function getCountryCode() {
    const { countryCode } = getHero();
    return countryCode
        ? COUNTRY_FLAGS[countryCode] + " " + countryCode
        : "+1 🇺🇸";
}

function getNationalNumber() {
    const { nationalNumber } = getHero();
    return nationalNumber;
}

export default (user) => html`
    <div
        id="hb-phone"
        tabindex="-1"
        class="hidden overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-[calc(100%-1rem)] max-h-full">
        <div class="relative p-4 w-full max-w-md max-h-full">
            <!-- Modal content -->
            <div
                class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                <!-- Modal header -->
                <div
                    class="flex items-center justify-between p-4 md:p-5 border-b rounded-t dark:border-gray-600 border-gray-200">
                    <h3
                        class="text-xl font-semibold text-gray-900 dark:text-white">
                        ${user?.phoneNumber ? "Update" : "Add"} Phone Number
                    </h3>
                    <button
                        type="button"
                        class="${isPopup
                            ? "hidden"
                            : "inline-flex"} end-2.5 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white"
                        data-modal-hide="hb-phone">
                        <svg
                            class="w-3 h-3"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 14 14">
                            <path
                                stroke="currentColor"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                stroke-width="2"
                                d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6" />
                        </svg>
                        <span class="sr-only">Close modal</span>
                    </button>
                </div>
                <!-- Modal body -->
                <div class="mt-4 p-4 md:p-5">
                    <form id="hb-phone-number" class="space-y-4">
                        <div class="flex items-center">
                            <button
                                id="hb-phone-number-cc"
                                data-dropdown-toggle="hb-phone-number-list"
                                class="shrink-0 z-10 inline-flex items-center py-2.5 px-4 text-sm font-medium text-center text-gray-900 bg-gray-100 border border-gray-300 rounded-s-lg hover:bg-gray-200 focus:ring-4 focus:outline-none focus:ring-gray-100 dark:bg-gray-700 dark:hover:bg-gray-600 dark:focus:ring-gray-700 dark:text-white dark:border-gray-600"
                                type="button">
                                <span>${getCountryCode()}</span>
                                <svg
                                    class="w-2.5 h-2.5 ms-2.5"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 10 6">
                                    <path
                                        stroke="currentColor"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                        stroke-width="2"
                                        d="m1 1 4 4 4-4" />
                                </svg>
                            </button>
                            <div
                                id="hb-phone-number-list"
                                class="z-10 hidden bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-52 dark:bg-gray-700">
                                <ul
                                    class="py-2 text-sm text-gray-700 dark:text-gray-200"
                                    aria-labelledby="hb-phone-number-list">
                                    <li id="hb-phone-number-us">
                                        <button
                                            type="button"
                                            class="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white"
                                            role="menuitem">
                                            <span
                                                class="inline-flex items-center">
                                                🇺🇸 United States (+1)
                                            </span>
                                        </button>
                                    </li>
                                    <li id="hb-phone-number-kh">
                                        <button
                                            type="button"
                                            class="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white"
                                            role="menuitem">
                                            <span
                                                class="inline-flex items-center">
                                                🇰🇭 Cambodia (+855)
                                            </span>
                                        </button>
                                    </li>
                                    <li id="hb-phone-number-fi">
                                        <button
                                            type="button"
                                            class="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white"
                                            role="menuitem">
                                            <span
                                                class="inline-flex items-center">
                                                🇫🇮 Finland (+358)
                                            </span>
                                        </button>
                                    </li>
                                    <li id="hb-phone-number-ua" class="hidden">
                                        <button
                                            type="button"
                                            class="inline-flex w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:text-gray-200 dark:hover:bg-gray-600 dark:hover:text-white"
                                            role="menuitem">
                                            <span
                                                class="inline-flex items-center">
                                                🇺🇦 Ukraine (+380)
                                            </span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                            <label
                                for="hb-phone-number-input"
                                class="sr-only mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                >Please enter your phone number:</label
                            >
                            <div class="relative w-full">
                                <input
                                    type="tel"
                                    autocomplete="tel"
                                    id="hb-phone-number-input"
                                    class="block outline-0 p-2.5 w-full z-20 text-base text-gray-900 bg-gray-50 rounded-e-lg border-s-0 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-s-gray-700  dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:border-blue-500"
                                    pattern2="[0-9]{3}-[0-9]{3}-[0-9]{4}"
                                    placeholder="${getNationalNumber() ||
                                    "80059THANK"}"
                                    required />
                            </div>
                        </div>
                        <!--<div>
                            <label
                                for="hb-phone-number-input"
                                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                >Please enter your phone number:
                            </label>
                            <input
                                type="tel"
                                autocomplete="tel"
                                id="hb-phone-number-input"
                                class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                placeholder="${user?.phoneNumber
                            ? user.phoneNumber
                            : "+180059THANK"}"
                                required />
                        </div>-->
                        <p
                            id="hb-phone-remove"
                            class="${user?.phoneNumber
                                ? "hidden"
                                : "hidden"} cursor-pointer text-sm font-medium text-blue-500 dark:text-blue-300">
                            Remove Phone Number
                        </p>
                        <button
                            type="submit"
                            class="w-full mt-3 text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                            Send Code
                        </button>
                    </form>
                    <form id="hb-phone-code" class="hidden space-y-4">
                        <div>
                            <label
                                for="hb-phone-code-input"
                                class="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                                >Please enter the code:
                            </label>
                            <input
                                type="number"
                                autocomplete="off"
                                id="hb-phone-code-input"
                                class="bg-gray-50 outline-0 border border-gray-300 text-gray-900 text-base rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-600 dark:border-gray-500 dark:placeholder-gray-400 dark:text-white"
                                placeholder="123456"
                                required />
                        </div>
                        <section class="flex items-center justify-between">
                            <p
                                id="hb-phone-back"
                                class="cursor-pointer text-sm font-medium text-blue-500 dark:text-blue-300">
                                Go Back
                            </p>
                            <p
                                id="hb-phone-resend"
                                class="cursor-pointer text-sm font-medium text-blue-500 dark:text-blue-300">
                                Resend Code
                            </p>
                        </section>
                        <button
                            type="submit"
                            class="w-full text-white bg-logo dark:bg-logo-dark cursor-pointer focus:ring-4 focus:outline-none focus:ring-logo/25 font-medium rounded-lg text-sm px-4 py-2 text-center">
                            Verify Code
                        </button>
                    </form>
                    <p
                        id="hb-phone-message"
                        class="text-sm font-medium mt-5 text-gray-500 dark:text-gray-300"></p>
                </div>
            </div>
        </div>
    </div>
`;
